// import { useEffect, useState } from "react";
// import { Container, Row, Col, Button } from "react-bootstrap";
// import nb from "../Assets/nb.png";
// import AOS from "aos";

// const HeroBanner = () => {
//   useEffect(() => {
//     AOS.init({
//       duration: 1500,
//       once: true,
//     });
//     window.scrollTo({ behavior: "smooth", top: 0 });
//   }, []);

//   const images = [
//     "https://d242nlqul83u9g.cloudfront.net/techbridge/work1.jpg",
//     "https://d242nlqul83u9g.cloudfront.net/techbridge/work2.jpg",
//     "https://d242nlqul83u9g.cloudfront.net/techbridge/work3.jpg",
//     "https://d242nlqul83u9g.cloudfront.net/techbridge/work4.jpg",
//     "https://d242nlqul83u9g.cloudfront.net/techbridge/work5.jpg",
//     "https://d242nlqul83u9g.cloudfront.net/techbridge/work6.jpg",
//     "https://d242nlqul83u9g.cloudfront.net/techbridge/work7.jpg",
//     "https://d242nlqul83u9g.cloudfront.net/techbridge/work8.jpg",
//     "https://d242nlqul83u9g.cloudfront.net/techbridge/work9.jpg",
//     "https://d242nlqul83u9g.cloudfront.net/techbridge/work10.jpg",

//     // w2,
//     // w5,
//     // w6,
//     // w7,
//     // w8,
//     // w9,
//     // w10,
//   ];

//   const [randomImage, setRandomImage] = useState("");

//   useEffect(() => {
//     const randomIndex = Math.floor(Math.random() * images.length);
//     setRandomImage(images[randomIndex]);
//   }, []);

//   const points = [
//     "6 months of intensive internship training",
//     "100% guaranteed job placement upon completion of internship",
//     "Corporate Readiness",
//   ];

//   return (
//     <section
//       style={{
//         background: "linear-gradient(180deg, black, black)",
//         color: "white",
//         minHeight: "700px",
//       }}
//     >
//       <Container fluid>
//         <Row className=" mx-3 py-5">
//           {/* Left Side Content */}
//           <Col md={6} className="px-5 d-flex flex-column" data-aos="fade-right">
//             <div className="d-flex flex-column justify-content-center  flex-grow-1">
//               {/* Heading fixed at top-left */}
//               <div className="my-5">
//                 <h2 className=" text-start name" style={{ fontWeight: "800" }}>
//                   TECH <span className="gradient-text">BRIDGE</span>{" "}
//                 </h2>
//                 <div>
//                   <span
//                     className="fs-5 text-light tagline fw-bold"
//                     style={{ fontStyle: "oblique" }}
//                   >
//                     EDUCATE • EMPLOY • ELEVATE
//                   </span>
//                 </div>
//               </div>
//               {/* Wrapper that takes full height and centers its content */}

//               <p className="mb-4 ">
//                 Join our comprehensive internship program, gain hands-on
//                 mentorship, structured learning, and regular evaluations to
//                 accelerate your professional growth and career readiness at{" "}
//                 <a
//                   href="https://nbmediatech.com/home"
//                   target="_blank"
//                   rel="noreferrer"
//                   className="text-white fw-bold "
//                 >
//                   our Company
//                 </a>
//               </p>
//               <ul className="nbmedia-points" style={{ paddingLeft: "0px" }}>
//                 {points.map((point, index) => (
//                   <li key={index} className="list-unstyled ">
//                     {" "}
//                     <img
//                       src="https://cdn.prod.website-files.com/62a8969da1ab561666c8c408/633afe7b71caab29c5b0d068_material-symbols_check-circle.svg"
//                       alt="check icon"
//                       className="icon-check-circle pe-3"
//                     />
//                     {point}
//                   </li>
//                 ))}
//               </ul>
//               <div class="my-5 animate-scale-in-bounce delay-400">
//                 <div className="d-inline-flex align-items-center border rounded-5 px-4 py-2 gap-3 text-center professional-glow prize-amount ">
//                   <a
//                     href="https://nbmediatech.com/home"
//                     target="_blank"
//                     rel="noreferrer"
//                     className="text-white fw-bold text-decoration-none "
//                   >
//                     <span
//                       class="fs-4 fw-bold"
//                       style={{ color: "rgb(0 253 255)" }}
//                     >
//                       100% GUARANTEED JOB PLACEMENT{" "}
//                     </span>

//                     <img
//                       src="	https://d242nlqul83u9g.cloudfront.net/adminpanel/carrermate/nblogo27300_IMG.png"
//                       style={{ width: "100%", maxWidth: "50px" }}
//                     />
//                   </a>
//                 </div>
//               </div>
//             </div>
//           </Col>

//           {/* Right Side Image */}
//           <Col
//             md={6}
//             className="text-center position-relative"
//             data-aos="fade-left"
//           >
//             {randomImage && (
//               <div
//                 style={{
//                   position: "relative",
//                   display: "inline-block",
//                   maxHeight: "900px",
//                   width: "100%",
//                 }}
//               >
//                 <img
//                   src={randomImage}
//                   alt="Random visual"
//                   className="img-fluid rounded shadow-lg"
//                   style={{
//                     maxHeight: "900px",

//                     width: "100%",
//                     // fade effect on all 4 sides
//                     WebkitMaskImage:
//                       "linear-gradient(to right, transparent, black 20%, black 85%, transparent), linear-gradient(to bottom, transparent, black 15%, black 85%, transparent)",
//                     WebkitMaskComposite: "destination-in",
//                     WebkitMaskRepeat: "no-repeat",
//                     WebkitMaskSize: "100% 100%",
//                     maskImage:
//                       "linear-gradient(to right, transparent, black 15%, black 85%, transparent), linear-gradient(to bottom, transparent, black 15%, black 85%, transparent)",
//                     maskComposite: "intersect",
//                     maskRepeat: "no-repeat",
//                     maskSize: "100% 100%",
//                   }}
//                 />
//               </div>
//             )}
//           </Col>
//         </Row>
//         {/*
//          <div data-aos="fade-up" className="container mt-5 pt-5">
//             <img className="heroimg" src="	https://d242nlqul83u9g.cloudfront.net/adminpanel/carrermate/code51710_IMG.png" />
//           </div> */}
//       </Container>
//     </section>
//   );
// };

// export default HeroBanner;

import { useEffect, useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import AOS from "aos";

const images = [
  // "https://d242nlqul83u9g.cloudfront.net/techbridge/work1.jpg",
  // "https://d242nlqul83u9g.cloudfront.net/techbridge/work2.jpg",
  // "https://d242nlqul83u9g.cloudfront.net/techbridge/work5.jpg",
  // "https://d242nlqul83u9g.cloudfront.net/techbridge/work7.jpg",
  // "https://d242nlqul83u9g.cloudfront.net/techbridge/work8.jpg",
  // "https://d242nlqul83u9g.cloudfront.net/techbridge/work9.jpg",
  // "https://d242nlqul83u9g.cloudfront.net/techbridge/work10.jpg",


  // "https://d242nlqul83u9g.cloudfront.net/adminpanel/carrermate/bg27437_IMG.png",
  // "https://d242nlqul83u9g.cloudfront.net/adminpanel/carrermate/bg26937_IMG.jpg",
  // "https://d242nlqul83u9g.cloudfront.net/techbridge/work7.jpg",
  // "https://d242nlqul83u9g.cloudfront.net/adminpanel/carrermate/bg62838_IMG.jpg",
  // "https://d242nlqul83u9g.cloudfront.net/adminpanel/carrermate/bg89916_IMG.jpg",
  // "https://d242nlqul83u9g.cloudfront.net/adminpanel/carrermate/bg32351_IMG.png"

  "https://d242nlqul83u9g.cloudfront.net/adminpanel/carrermate/techbridge19663_IMG.png",
  "https://d242nlqul83u9g.cloudfront.net/adminpanel/carrermate/techbridge30217_IMG.png",
  "https://d242nlqul83u9g.cloudfront.net/adminpanel/carrermate/techbridge56357_IMG.png",
  "https://d242nlqul83u9g.cloudfront.net/adminpanel/carrermate/techbridge79235_IMG.png",
  "https://d242nlqul83u9g.cloudfront.net/adminpanel/carrermate/techbridge21558_IMG.png",


];

const HeroBanner = () => {
  useEffect(() => {
    AOS.init({
      duration: 1500,
      once: true,
    });
    window.scrollTo({ behavior: "smooth", top: 0 });
  }, []);

  const [randomImage, setRandomImage] = useState("");

  useEffect(() => {
    const randomIndex = Math.floor(Math.random() * images.length);
    setRandomImage(images[randomIndex]);
  }, []);

  // const points = [
  //   "6 months of intensive internship training",
  //   "100% guaranteed job placement upon completion",
  //   "Corporate Readiness",
  // ];

  return (
    <section
      style={{
        minHeight: "700px",
        position: "relative",
        display: "flex",
        alignItems: "center",
        backgroundImage: `url(${randomImage})`,
        backgroundSize: "cover",
        backgroundPosition: "top",
        backgroundRepeat: "no-repeat",
        overflow: "hidden",
      }}
    >
      {/* Dark overlay */}
      <div
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          background: "rgba(0,0,0,0.1)",
          zIndex: 1,
        }}
      />

      {/* Left-right fade overlay */}
      <div
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          background:
            "linear-gradient(to right, rgba(0,0,0,0.8) 0%, rgba(0, 0, 0, 0.6) 30%,rgba(0, 0, 0, 0) 50%, rgba(0,0,0,0) 80%, rgba(0,0,0,0.6) 100%)",
          zIndex: 2,
          pointerEvents: "none",
        }}
      />

      {/* Bottom fade overlay */}
      <div
        style={{
          position: "absolute",
          bottom: 0,
          left: 0,
          width: "100%",
          height: "30%", // adjust height for fade effect
          background: "linear-gradient(to top, black, transparent)",
          zIndex: 2,
          pointerEvents: "none",
        }}
      />

      {/* Content container */}
      <Container style={{ position: "relative", zIndex: 3 }}>
        <Row className="align-items-center">
          <Col
            md={6}
            className="d-flex flex-column justify-content-center text-start"
            data-aos="fade-right"
          >
          
            <h1
              className="tagline gradient-text"
              style={{ fontStyle: "oblique", fontWeight: "800" }}
            >
              Launch Your IT Career with Real Industry Experience
            </h1>
            <p className="text-white">
              At <b>Tech Bridge</b>, we prepare aspiring IT professionals through live product development, hands-on industry exposure, expert mentorship, and structured career pathways
            </p>
            <div className="my-3 animate-scale-in-bounce delay-400">
              <div className="d-inline-flex align-items-center border rounded-5 px-4 py-2 gap-3 text-center professional-glow prize-amount">
                <a
                href="/enquire"
                  className="fs-4 fw-bold text-decoration-none"
                  style={{ color: "rgb(0 253 255)" }}
                >
                  Apply Now{" "}
                </a>
               
              </div>
            </div>
          </Col>
        </Row>
      </Container>

      {/* Right bottom box with list */}
      <div
        style={{
          position: "absolute",
          bottom: "30px",
          right: "30px",
          background: "rgba(0,0,0,0.6)",
          padding: "20px",
          borderRadius: "12px",
          color: "white",
          zIndex: 3,
          maxWidth: "300px",
        }}
        data-aos="fade-up"
      >
        {/* <ul className="list-unstyled mb-0">
          {points.map((point, index) => (
            <li key={index} className="mb-2 d-flex align-items-start">
              <img
                src="https://cdn.prod.website-files.com/62a8969da1ab561666c8c408/633afe7b71caab29c5b0d068_material-symbols_check-circle.svg"
                alt="check"
                style={{ width: "20px", marginRight: "10px" }}
              />
              {point}
            </li>
          ))}
        </ul> */}
      </div>
    </section>
  );
};

export default HeroBanner;
